module.exports = __webpack_public_path__ + "static/media/19ESCAP10.687050ef.jpg";